module.exports = __webpack_public_path__ + "shopify.c659fc8b1c28cbf5505a060123baa323.png";